import { Paper } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import Box from '../box';
import Typography from '../typography';
import styles from './styles.module.scss';

export const GreyBox = ({ title, children }) => (
    <Paper elevation={0} square classes={{ root: styles.paper }}>
        <Box p={3}>
            <Typography component="h3" className={styles.header}>
                {title}
            </Typography>
            {children}
        </Box>
    </Paper>
);

GreyBox.propTypes = {
    children: PropTypes.node,
    title: PropTypes.node
};

GreyBox.defaultProps = {
    children: null,
    title: null
};
